module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAAAXNSR0IB2cksfwAAADNQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAowVGyQAAABF0Uk5TAAQQGCAMLEA4JAgoMDw0FByQOd4rAAAAzUlEQVR4nKWTSwLDIAhEwU/E+Enuf9pi2ihqYxdlJ6PDUwGgBSptjFEWvobe3CfI77NKTkbod2B0QyQtZJtrvtn4djrduQ1BTRuwnS7oFdN9Snj3oKcLchdUnT/fouih4+6vyQbYJXJMcsmIh1yz4S430GBvx3oWupcrPEYmFNBSN+D+1Nf1j59851JHsCt94zUt9PLD+lmn6//zo/5uEEGAXbvEu7dr5pQ8Ge8GbZbe1PdIYo4k43T6YhgHxCwHLMwDyJ11RnahGA5h/QKT2hOa2F7AtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/more-info@2x.png
// module id = 873
// module chunks = 0